import useSWR from 'swr';

import { FetchError } from 'exceptions/FetchError';
import { apiUrls } from 'services/api-urls';
import { fetcher } from 'services/fetcher';

type HookReturn = {
  isLoaded: boolean;
  token?: string;
  errorMessage?: string;
};

type GenerateTokenResponseSuccess = {
  token: string;
};

function useColissimoToken(): HookReturn {
  const colissimoTokenUrl = apiUrls.getColissimoGenerateToken();
  const { data, error, isValidating } = useSWR<
    GenerateTokenResponseSuccess,
    FetchError
  >(
    colissimoTokenUrl,
    url =>
      fetcher(url, true).then(async response => {
        const json = await response.json();
        if (response.status !== 200) {
          throw new FetchError(json.message);
        }

        return json;
      }),
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: true,
      revalidateIfStale: false,
      refreshInterval: 1500000, // 25 minute intervals
    }
  );

  return {
    isLoaded: !isValidating,
    token: data?.token || undefined,
    errorMessage: error?.message || undefined,
  };
}

export default useColissimoToken;
